export const EmailIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.33301 4L5.94169 6.61131C7.64074 7.574 8.35861 7.574 10.0577 6.61131L14.6663 4"
      stroke="currentColor"
      strokeLinejoin="round"
    />
    <path
      d="M1.34352 8.98365C1.3871 11.0274 1.40889 12.0492 2.16298 12.8062C2.91706 13.5631 3.96656 13.5895 6.06556 13.6422C7.35921 13.6747 8.64014 13.6747 9.93381 13.6422C12.0328 13.5895 13.0823 13.5631 13.8364 12.8062C14.5905 12.0492 14.6123 11.0274 14.6558 8.98365C14.6699 8.32652 14.6699 7.67332 14.6558 7.01619C14.6123 4.97249 14.5905 3.95065 13.8364 3.19369C13.0823 2.43674 12.0328 2.41037 9.93381 2.35763C8.64014 2.32513 7.35921 2.32513 6.06555 2.35763C3.96656 2.41036 2.91706 2.43673 2.16297 3.19369C1.40889 3.95064 1.3871 4.97249 1.34351 7.01619C1.3295 7.67332 1.32951 8.32652 1.34352 8.98365Z"
      stroke="currentColor"
      strokeLinejoin="round"
    />
  </svg>
);
